export const ContactMap = () => (
  <section className="px-6 lg:px-10 pb-28">
    <div className="max-w-[1300px] mx-auto">
      <div className="rounded-2xl overflow-hidden border border-white/5 h-[420px] relative">
        <iframe
          data-testid="contact-map" title="Membratek Konum"
          src="https://www.google.com/maps?q=Gaziantep%202.%20Organize%20Sanayi%20Bolgesi&output=embed"
          width="100%" height="100%" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
          style={{ border: 0, filter: 'invert(0.92) hue-rotate(180deg) brightness(0.85)' }}
        />
      </div>
    </div>
  </section>
);